import { render, staticRenderFns } from "./customer-factory-summary.vue?vue&type=template&id=c79f78a2&scoped=true&"
import script from "./customer-factory-summary.vue?vue&type=script&lang=js&"
export * from "./customer-factory-summary.vue?vue&type=script&lang=js&"
import style0 from "./customer-factory-summary.vue?vue&type=style&index=0&id=c79f78a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79f78a2",
  null
  
)

export default component.exports